(() => {
  const TCB = window.TCB || { routes: { root: '/', cart: '/cart', cartAdd: '/cart/add', cartChange: '/cart/change' }, cartType: 'drawer' };
  const STR = TCB.strings || {};
  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));
  // Browser storage can be blocked (private windows), so every read and write is guarded.
  const keep = (area) => ({
    get(k) { try { return window[area].getItem(k); } catch (e) { return null; } },
    set(k, v) { try { window[area].setItem(k, v); } catch (e) { /* not saved */ } }
  });
  const store = keep('localStorage');
  const session = keep('sessionStorage');

  /* ---------- dialogs (cart drawer, mobile menu) ---------- */
  let lastFocus = null;
  function focusables(container) {
    return $$('a[href],button:not([disabled]),input:not([type=hidden]),select,textarea,[tabindex]:not([tabindex="-1"])', container)
      .filter((el) => el.offsetParent !== null);
  }
  function openDialog(el) {
    if (!el) return;
    lastFocus = document.activeElement;
    el.hidden = false;
    requestAnimationFrame(() => el.classList.add('is-open'));
    document.documentElement.classList.add('tcb-lock');
    const first = focusables(el)[0];
    if (first) setTimeout(() => first.focus(), 50);
  }
  function closeDialog(el) {
    if (!el || el.hidden) return;
    el.classList.remove('is-open');
    document.documentElement.classList.remove('tcb-lock');
    setTimeout(() => { el.hidden = true; }, 200);
    if (lastFocus) lastFocus.focus();
  }
  document.addEventListener('keydown', (e) => {
    const open = $$('[data-cart-drawer]:not([hidden]), [data-menu]:not([hidden]), [data-popup]:not([hidden])')[0];
    if (!open) return;
    if (e.key === 'Escape') { if (open.matches('[data-popup]')) closePopup(); else closeDialog(open); return; }
    if (e.key === 'Tab') {
      const items = focusables(open);
      if (!items.length) return;
      const first = items[0];
      const last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  /* ---------- cart ---------- */
  const drawer = () => $('[data-cart-drawer]');
  function updateCount(count) {
    if (count === undefined || count === null) return;
    const n = Number(count);
    $$('[data-cart-count]').forEach((el) => { el.textContent = n; el.hidden = n === 0; });
  }
  function renderCart(sections) {
    const html = sections && sections['cart-drawer'];
    const d = drawer();
    if (!html || !d) return;
    const fresh = $('.tcb-cart__panel', new DOMParser().parseFromString(html, 'text/html'));
    const panel = $('.tcb-cart__panel', d);
    if (fresh && panel) {
      panel.innerHTML = fresh.innerHTML;
      updateCount(fresh.dataset.count);
    }
  }
  async function cartRequest(url, body) {
    const res = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ ...body, sections: ['cart-drawer'], sections_url: window.location.pathname })
    });
    const data = await res.json();
    if (!res.ok || data.status) throw new Error(data.description || data.message || 'Something went wrong. Please try again.');
    return data;
  }
  /* Quantity changes are optimistic: the number updates on click, rapid clicks are
     batched into one request per line, requests go out one at a time, and only the last
     one re-renders the drawer, so the number never jumps back while Shopify responds. */
  const pendingLines = new Map(); // line element -> { t: timer, q: quantity }
  const inflight = new Set();
  let cartSeq = 0;
  let cartFailed = false;
  const inDrawer = (sel) => { const d = drawer(); return d ? $(sel, d) : null; };
  const setBusy = (on) => { const p = inDrawer('.tcb-cart__panel'); if (p) p.classList.toggle('is-busy', on); };
  function showCartError(msg) {
    const err = inDrawer('[data-cart-error]');
    if (err && msg) { err.textContent = msg; err.hidden = false; }
  }
  function renderCartKeepFocus(sections) {
    const active = document.activeElement;
    const line = active && active.closest && active.closest('[data-line]');
    const idx = line ? $$('[data-line-qty]', line).indexOf(active) : -1;
    const variant = line && line.dataset.variant;
    renderCart(sections);
    if (variant && idx > -1) {
      const fresh = inDrawer(`[data-line][data-variant="${CSS.escape(variant)}"]`);
      const btn = fresh && $$('[data-line-qty]', fresh)[idx];
      const target = btn && btn.disabled ? $$('[data-line-qty]:not([disabled])', fresh)[0] : btn;
      if (target) target.focus();
      else { const c = inDrawer('button[data-cart-close]'); if (c) c.focus(); }
    }
  }
  async function refreshCart() {
    try {
      const res = await fetch(`${window.location.pathname}?sections=cart-drawer`);
      if (res.ok) renderCartKeepFocus(await res.json());
    } catch (e) {}
  }
  // Shopify changes a line's key whenever its discounts change, so lines are tracked by
  // element and the key is read at send time.
  function syncKeys(items) {
    const d = drawer();
    if (!Array.isArray(items) || !d) return;
    const byVariant = new Map();
    items.forEach((it) => {
      const list = byVariant.get(String(it.variant_id)) || [];
      list.push(it.key);
      byVariant.set(String(it.variant_id), list);
    });
    $$('[data-line]', d).forEach((el) => {
      const list = byVariant.get(el.dataset.variant);
      if (list && list.length) el.dataset.line = list.shift();
    });
  }
  function queueLine(line, quantity) {
    const q = Math.max(0, quantity);
    const prev = pendingLines.get(line);
    if (prev) clearTimeout(prev.t);
    pendingLines.delete(line);
    const err = inDrawer('[data-cart-error]');
    if (err) err.hidden = true;
    setBusy(true);
    if (q === 0) {
      line.classList.add('is-removing');
      changeLine(line, 0);
      return;
    }
    const num = $('[data-line-count]', line);
    if (num) num.textContent = q;
    const btns = $$('.tcb-qty [data-line-qty]', line);
    if (btns[0]) { btns[0].dataset.lineQty = q - 1; btns[0].disabled = q <= 1; }
    if (btns[1]) btns[1].dataset.lineQty = q + 1;
    pendingLines.set(line, { q, t: setTimeout(() => { pendingLines.delete(line); changeLine(line, q); }, 300) });
  }
  // Cart updates run strictly one after another. Two at once can reach Shopify out of
  // order, so an older quantity could land last and the cart would snap back to it.
  let cartChain = Promise.resolve();
  function changeLine(line, quantity) {
    const job = cartChain.then(() => sendLine(line, quantity));
    cartChain = job.catch(() => {});
    inflight.add(job);
    job.finally(() => inflight.delete(job));
    return job;
  }
  // Sends every queued change now and resolves once Shopify has confirmed all of them.
  async function flushCart() {
    pendingLines.forEach((p, line) => { clearTimeout(p.t); pendingLines.delete(line); changeLine(line, p.q); });
    while (inflight.size) await Promise.allSettled([...inflight]);
  }
  const cartBusy = () => pendingLines.size > 0 || inflight.size > 0;
  async function sendLine(line, quantity) {
    const key = line.dataset.line;
    const seq = ++cartSeq;
    cartFailed = false;
    // Only the last update in line may redraw the cart; earlier answers would show stale numbers.
    const latest = () => seq === cartSeq && pendingLines.size === 0 && inflight.size <= 1;
    try {
      const res = await fetch(`${TCB.routes.cartChange}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity, sections: ['cart-drawer'], sections_url: window.location.pathname })
      });
      const data = await res.json();
      if (!res.ok || data.status) {
        cartFailed = true;
        if (latest()) {
          await refreshCart();
          showCartError(data.description || data.message || STR.cartError);
        }
        return;
      }
      syncKeys(data.items);
      if (!latest()) return; // a newer change is on its way and will render
      renderCartKeepFocus(data.sections);
      updateCount(data.item_count);
    } catch (e) {
      cartFailed = true;
      if (latest()) { await refreshCart(); showCartError(STR.cartError); }
    } finally {
      if (latest()) setBusy(false);
    }
  }
  // Checkout from the drawer waits until every quantity change has reached Shopify,
  // so the order never opens with an out-of-date quantity.
  document.addEventListener('submit', async (e) => {
    const form = e.target;
    const btn = e.submitter;
    if (!form.closest('[data-cart-drawer]') || !btn || btn.name !== 'checkout' || !cartBusy()) return;
    e.preventDefault();
    const label = btn.textContent;
    btn.disabled = true;
    btn.classList.add('is-loading');
    if (STR.cartUpdating) btn.textContent = STR.cartUpdating;
    await flushCart();
    const fresh = inDrawer('button[name="checkout"]');
    if (!cartFailed && fresh && !cartBusy()) { fresh.click(); return; }
    if (btn.isConnected) { btn.disabled = false; btn.classList.remove('is-loading'); btn.textContent = label; }
  });

  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-popup-close]')) { e.preventDefault(); closePopup(); return; }
    if (e.target.closest('[data-popup-tab]')) { e.preventDefault(); openPopup(); return; }
    const openCart = e.target.closest('[data-cart-open]');
    if (openCart && drawer() && TCB.cartType === 'drawer') { e.preventDefault(); openDialog(drawer()); return; }
    if (e.target.closest('[data-cart-close]')) { e.preventDefault(); closeDialog(drawer()); return; }
    const qty = e.target.closest('[data-line-qty]');
    if (qty) {
      const line = qty.closest('[data-line]');
      if (line) { e.preventDefault(); queueLine(line, Number(qty.dataset.lineQty)); }
      return;
    }
    // "View cart" also waits for pending changes, so the cart page shows the right quantities.
    const view = e.target.closest('[data-cart-view]');
    if (view && cartBusy()) { e.preventDefault(); flushCart().then(() => { window.location.href = view.href; }); return; }
    if (e.target.closest('[data-menu-open]')) { e.preventDefault(); openDialog($('[data-menu]')); return; }
    if (e.target.closest('[data-menu-close]')) { e.preventDefault(); closeDialog($('[data-menu]')); return; }

    /* accordions + FAQ */
    const toggle = e.target.closest('[data-toggle]');
    if (toggle) {
      const row = toggle.closest('[data-toggle-row]');
      const panel = document.getElementById(toggle.getAttribute('aria-controls'));
      const open = !row.classList.contains('is-open');
      row.classList.toggle('is-open', open);
      toggle.setAttribute('aria-expanded', String(open));
      if (panel) panel.hidden = !open;
      return;
    }

    /* inline video play */
    const play = e.target.closest('[data-video-play]');
    if (play) {
      const video = $('video', play.closest('[data-video]'));
      if (video) {
        if (video.paused) { video.muted = false; video.play(); play.hidden = true; video.controls = true; }
        else video.pause();
      }
    }
  });

  /* ---------- product page ---------- */
  function initProduct(section) {
    if (!section || section.dataset.ready) return;
    section.dataset.ready = '1';
    const json = $('[data-product-json]', section);
    const data = json ? JSON.parse(json.textContent) : { variants: [] };
    const form = $('form.tcb-product-form', section);
    const idInput = form && $('[data-variant-id]', form);
    const qtyInput = form && $('[data-qty-input]', form);

    /* gallery */
    const slides = $$('.tcb-gallery__slide', section);
    const thumbs = $$('[data-thumb]', section);
    const dots = $$('.tcb-dots i', section);
    function show(id) {
      let index = 0;
      slides.forEach((s, i) => { const on = s.dataset.mediaId === String(id); s.hidden = !on; if (on) index = i; });
      thumbs.forEach((t) => t.classList.toggle('is-active', t.dataset.thumb === String(id)));
      dots.forEach((d, i) => d.classList.toggle('is-active', i === index));
      $$('video', section).forEach((v) => { if (v.closest('[hidden]')) v.pause(); });
    }
    thumbs.forEach((t) => t.addEventListener('click', () => show(t.dataset.thumb)));
    dots.forEach((d, i) => d.addEventListener('click', () => slides[i] && show(slides[i].dataset.mediaId)));
    const main = $('.tcb-gallery__main', section);
    if (main && slides.length > 1) {
      let startX = null;
      main.addEventListener('touchstart', (e) => { startX = e.touches[0].clientX; }, { passive: true });
      main.addEventListener('touchend', (e) => {
        if (startX === null) return;
        const dx = e.changedTouches[0].clientX - startX;
        startX = null;
        if (Math.abs(dx) < 40) return;
        const cur = slides.findIndex((s) => !s.hidden);
        const next = (cur + (dx < 0 ? 1 : -1) + slides.length) % slides.length;
        show(slides[next].dataset.mediaId);
      });
    }

    /* quantity */
    $$('[data-qty]', section).forEach((btn) => btn.addEventListener('click', () => {
      const value = $('[data-qty-value]', section);
      const n = Math.max(1, Number(qtyInput.value) + Number(btn.dataset.qty));
      qtyInput.value = n;
      if (value) value.textContent = n;
    }));

    /* variant pills */
    const options = $$('.tcb-option', section);
    function selected() {
      return options.map((o) => { const p = $('.tcb-pill.is-selected', o); return p ? p.dataset.optionValue : null; });
    }
    function applyVariant() {
      const values = selected();
      const variant = data.variants.find((v) => v.options.every((val, i) => val === values[i]));
      $$('.tcb-pill', section).forEach((pill) => {
        const oi = Number(pill.closest('.tcb-option').dataset.optionIndex);
        const test = values.slice();
        test[oi] = pill.dataset.optionValue;
        const match = data.variants.find((v) => v.options.every((val, i) => val === test[i]));
        pill.classList.toggle('is-soldout', !match || !match.available);
      });
      const addButtons = $$('[data-add-button]', section);
      if (!variant) {
        addButtons.forEach((b) => { b.disabled = true; b.textContent = b.dataset.soldout; });
        return;
      }
      if (idInput) idInput.value = variant.id;
      addButtons.forEach((b) => { b.disabled = !variant.available; b.textContent = variant.available ? b.dataset.label : b.dataset.soldout; });
      const buyNow = $('[data-buy-now]', section);
      if (buyNow) buyNow.disabled = !variant.available;
      $$('[data-price-current]', section).forEach((el) => { el.textContent = variant.price; });
      const compare = $('[data-price-compare]', section);
      if (compare) { compare.hidden = !variant.compare; if (variant.compare) compare.textContent = variant.compare; }
      const save = $('[data-price-save]', section);
      if (save) { save.hidden = !variant.compare; save.textContent = save.dataset.label.replace('[amount]', variant.saving); }
      const badge = $('[data-sale-badge]', section);
      if (badge) badge.hidden = !variant.compare;
      if (variant.media) show(variant.media);
      if (data.url && window.history.replaceState) {
        window.history.replaceState({}, '', `${data.url}?variant=${variant.id}`);
      }
    }
    options.forEach((o) => {
      $$('.tcb-pill', o).forEach((pill) => pill.addEventListener('click', () => {
        $$('.tcb-pill', o).forEach((p) => { p.classList.remove('is-selected'); p.setAttribute('aria-checked', 'false'); });
        pill.classList.add('is-selected');
        pill.setAttribute('aria-checked', 'true');
        const label = $('[data-option-selected]', o);
        if (label) label.textContent = pill.dataset.optionValue;
        applyVariant();
      }));
    });

    /* add to cart */
    if (form) {
      form.addEventListener('submit', async (e) => {
        const submitter = e.submitter;
        if (submitter && submitter.hasAttribute('data-buy-now')) return; // normal post, then checkout
        if (TCB.cartType !== 'drawer' || !drawer()) return;
        e.preventDefault();
        const err = $('[data-form-error]', form);
        $$('[data-add-button]', section).forEach((b) => b.classList.add('is-loading'));
        try {
          const data = await cartRequest(`${TCB.routes.cartAdd}.js`, { items: [{ id: Number(idInput.value), quantity: Number(qtyInput.value) }] });
          if (err) err.hidden = true;
          renderCart(data.sections);
          openDialog(drawer());
        } catch (ex) {
          if (err) { err.textContent = ex.message; err.hidden = false; }
        } finally {
          $$('[data-add-button]', section).forEach((b) => b.classList.remove('is-loading'));
        }
      });
    }
  }

  /* ---------- related products ---------- */
  function initRecommendations(el) {
    if (!el || el.dataset.ready) return;
    el.dataset.ready = '1';
    fetch(el.dataset.recommendations)
      .then((r) => r.text())
      .then((html) => {
        const fresh = $('[data-recommendations-grid]', new DOMParser().parseFromString(html, 'text/html'));
        const grid = $('[data-recommendations-grid]', el);
        if (fresh && grid && fresh.children.length) grid.innerHTML = fresh.innerHTML;
      })
      .catch(() => {});
  }

  /* ---------- sticky header ---------- */
  function initHeader() {
    const header = $('[data-header][data-sticky]');
    if (!header || header.dataset.ready) return;
    header.dataset.ready = '1';
    const wrapper = header.closest('.shopify-section') || header.parentElement;
    let stuck = false;
    // Pinned things (the product gallery) sit below the stuck header via --tcb-sticky-h.
    const setOffset = () => document.documentElement.style.setProperty('--tcb-sticky-h', stuck ? `${header.offsetHeight}px` : '0px');
    const onScroll = () => {
      const limit = wrapper.offsetTop + wrapper.offsetHeight;
      const should = window.scrollY > limit;
      if (should === stuck) return;
      stuck = should;
      wrapper.style.minHeight = should ? `${wrapper.offsetHeight}px` : '';
      header.classList.toggle('tcb-header--sticky', should);
      setOffset();
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', () => { if (stuck) setOffset(); }, { passive: true });
    onScroll();
  }

  /* ---------- sign-up popup ---------- */
  // Opens once the visitor has been on the site for "Show after" (counted across pages). If they
  // close it, it waits "Show again after" days, and the corner tab lets them open it sooner.
  // Signing up through any email form stops both for good.
  const POP_KEY = 'tcb_popup';
  const POP_FORM = 'SignupPopupForm';
  const popup = () => $('[data-popup]');
  function openPopup() {
    const p = popup();
    if (!p || !p.hidden) return;
    if (store.get(POP_KEY) !== 'done') store.set(POP_KEY, String(Date.now()));
    setTab(false);
    openDialog(p);
  }
  function closePopup() {
    const p = popup();
    if (!p || p.hidden) return;
    closeDialog(p);
    setTab(store.get(POP_KEY) !== 'done');
  }
  function setTab(show) {
    const tab = $('[data-popup-tab]');
    if (tab) tab.hidden = !show;
  }
  function initPopup() {
    const p = popup();
    if (!p || p.dataset.ready) return;
    p.dataset.ready = '1';
    initPopupForm(p);
    // In the theme editor the tab stays visible so its text can be edited.
    if (window.Shopify && window.Shopify.designMode) { setTab(true); return; }
    // Shopify adds the form's id to the address when this form was the one sent.
    const sentHere = decodeURIComponent(window.location.hash.slice(1)) === POP_FORM;
    // No thank-you template means Shopify just rendered a successful sign-up.
    if (!$('[data-popup-done]', p)) {
      store.set(POP_KEY, 'done');
      if (sentHere) openPopup();
      return;
    }
    if (sentHere && $('[data-popup-error]', p)) { openPopup(); return; }
    const state = store.get(POP_KEY);
    if (state === 'done') return;
    if (state) setTab(true);
    if (state && Date.now() - Number(state) < Number(p.dataset.days || 14) * 864e5) return;
    let start = Number(session.get('tcb_popup_start'));
    if (!start) { start = Date.now(); session.set('tcb_popup_start', String(start)); }
    const wait = Math.max(0, Number(p.dataset.delay || 0) * 1000 - (Date.now() - start));
    // Never on top of the cart or menu: try again a little later.
    const tryOpen = () => {
      if ($$('[data-cart-drawer]:not([hidden]), [data-menu]:not([hidden])').length) setTimeout(tryOpen, 3000);
      else openPopup();
    };
    setTimeout(tryOpen, wait);
  }
  /* The sign-up is sent in the background so the page doesn't reload and lose the visitor's place.
     A bot check, or a response we don't recognise, falls back to a normal submit. */
  function initPopupForm(p) {
    const form = $('form', p);
    if (!form) return;
    const submit = () => HTMLFormElement.prototype.submit.call(form);
    const showDone = () => {
      const state = $('[data-popup-state]', p);
      const done = $('[data-popup-done]', p);
      if (!state || !done) return;
      state.innerHTML = done.innerHTML;
      done.remove();
      store.set(POP_KEY, 'done');
      const btn = $('[data-popup-close]', state);
      if (btn) btn.focus({ preventScroll: true });
    };
    const showError = (msg) => {
      let err = $('[data-popup-error]', form);
      if (!err) {
        err = document.createElement('p');
        err.className = 'tcb-form-msg';
        err.setAttribute('role', 'alert');
        err.setAttribute('data-popup-error', '');
        $('.tcb-popup__fields', form).after(err);
      }
      err.textContent = msg;
      err.hidden = false;
    };
    form.addEventListener('submit', async (e) => {
      if (!$('[data-popup-done]', p)) return;
      e.preventDefault();
      const btn = $('button[type="submit"]', form);
      if (btn) { btn.disabled = true; btn.classList.add('is-loading'); }
      const old = $('[data-popup-error]', form);
      if (old) old.hidden = true;
      try {
        const res = await fetch(form.action, { method: 'POST', body: new FormData(form), headers: { Accept: 'text/html' } });
        const url = res.url || '';
        if (url.includes('/challenge')) { submit(); return; }
        if (url.includes('customer_posted=true')) { showDone(); return; }
        const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
        const err = $(`#${POP_FORM} [data-popup-error]`, doc);
        if (err && err.textContent.trim()) showError(err.textContent.trim());
        else submit();
      } catch (err) {
        submit();
      } finally {
        if (btn && btn.isConnected) { btn.disabled = false; btn.classList.remove('is-loading'); }
      }
    });
  }

  function init() {
    $$('[data-product-section]').forEach(initProduct);
    $$('[data-recommendations]').forEach(initRecommendations);
    initHeader();
    initPopup();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  /* ---------- theme editor ---------- */
  document.addEventListener('shopify:section:load', init);
  // Keep the popup open while its settings are edited (each change re-renders it closed).
  document.addEventListener('shopify:section:load', (e) => {
    if (e.target.querySelector('[data-popup]')) { setTab(false); openDialog(popup()); }
  });
  document.addEventListener('shopify:section:select', (e) => {
    if (e.target.querySelector('[data-cart-drawer]')) openDialog(drawer());
    if (e.target.querySelector('[data-popup]')) { setTab(false); openDialog(popup()); }
  });
  document.addEventListener('shopify:section:deselect', (e) => {
    if (e.target.querySelector('[data-cart-drawer]')) closeDialog(drawer());
    if (e.target.querySelector('[data-popup]')) { closeDialog(popup()); setTab(true); }
  });
  document.addEventListener('shopify:block:select', (e) => {
    const row = e.target.closest('[data-toggle-row]');
    if (row && !row.classList.contains('is-open')) { const t = $('[data-toggle]', row); if (t) t.click(); }
  });
})();
